exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.margin-top[data-v-30430bf2]{margin-top:10px\n}\n[data-v-30430bf2] .text .text{color:#ff0000 !important\n}\n", "", {"version":3,"sources":["/app/frontend/src/components/informacoesCadastro/cadastrosOnline/InformacoesInteressado.vue"],"names":[],"mappings":";AAwHA,6BACE,eAAgB;CACjB;AAAA,8BAEG,wBAAyB;CAC1B","file":"InformacoesInteressado.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.margin-top {\n  margin-top: 10px;\n}\n>>> .text .text{\n    color: #ff0000 !important;\n  }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-30430bf2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/informacoesCadastro/cadastrosOnline/InformacoesInteressado.vue
// module id = gjbt
// module chunks = 11